function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var REGISTER_DEVICE = {
  BEGIN: 'REGISTER_DEVICE_BEGIN',
  SUCCESS: 'REGISTER_DEVICE_SUCCESS',
  FAILURE: 'REGISTER_DEVICE_FAILURE'
};
var REGISTER_DEVICE_TYPES = [REGISTER_DEVICE.BEGIN, REGISTER_DEVICE.SUCCESS, REGISTER_DEVICE.FAILURE];
export var REMOVE_DEVICE = {
  BEGIN: 'REMOVE_DEVICE_BEGIN',
  SUCCESS: 'REMOVE_DEVICE_SUCCESS',
  FAILURE: 'REMOVE_DEVICE_FAILURE'
};
var REMOVE_DEVICE_TYPES = [REMOVE_DEVICE.BEGIN, REMOVE_DEVICE.SUCCESS, REMOVE_DEVICE.FAILURE];
export var RETRIEVE_DEVICES = {
  BEGIN: 'RETRIEVE_DEVICES_BEGIN',
  SUCCESS: 'RETRIEVE_DEVICES_SUCCESS',
  FAILURE: 'RETRIEVE_DEVICES_FAILURE'
};
var RETRIEVE_DEVICES_TYPES = [RETRIEVE_DEVICES.BEGIN, RETRIEVE_DEVICES.SUCCESS, RETRIEVE_DEVICES.FAILURE];
export var UPDATE_DEVICE = {
  BEGIN: 'UPDATE_DEVICES_BEGIN',
  SUCCESS: 'UPDATE_DEVICES_SUCCESS',
  FAILURE: 'UPDATE_DEVICES_FAILURE'
};
var UPDATE_DEVICE_TYPES = [UPDATE_DEVICE.BEGIN, UPDATE_DEVICE.SUCCESS, UPDATE_DEVICE.FAILURE];
export var RETRIEVE_DEVICE_FINANCING_DETAILS = {
  BEGIN: 'RETRIEVE_DEVICE_FINANCING_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_DEVICE_FINANCING_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_DEVICE_FINANCING_DETAILS_FAILURE'
};
var RETRIEVE_DEVICE_FINANCING_DETAILS_TYPES = [RETRIEVE_DEVICE_FINANCING_DETAILS.BEGIN, RETRIEVE_DEVICE_FINANCING_DETAILS.SUCCESS, RETRIEVE_DEVICE_FINANCING_DETAILS.FAILURE];
export var RETRIEVE_DEVICE_REFUND_AMOUNT = {
  BEGIN: 'RETRIEVE_DEVICE_REFUND_AMOUNT_BEGIN',
  SUCCESS: 'RETRIEVE_DEVICE_REFUND_AMOUNT_SUCCESS',
  FAILURE: 'RETRIEVE_DEVICE_REFUND_AMOUNT_FAILURE'
};
var RETRIEVE_DEVICE_REFUND_AMOUNT_TYPES = [RETRIEVE_DEVICE_REFUND_AMOUNT.BEGIN, RETRIEVE_DEVICE_REFUND_AMOUNT.SUCCESS, RETRIEVE_DEVICE_REFUND_AMOUNT.FAILURE];
export var CREATE_DEVICE_ADJUSTMENT = {
  BEGIN: 'CREATE_DEVICE_ADJUSTMENT_BEGIN',
  SUCCESS: 'CREATE_DEVICE_ADJUSTMENT_SUCCESS',
  FAILURE: 'CREATE_DEVICE_ADJUSTMENT_FAILURE'
};
var CREATE_DEVICE_ADJUSTMENT_TYPE = [CREATE_DEVICE_ADJUSTMENT.BEGIN, CREATE_DEVICE_ADJUSTMENT.SUCCESS, CREATE_DEVICE_ADJUSTMENT.FAILURE];
export var CLEAR_DEVICE_FORM = 'CLEAR_DEVICE_FORM';
export var clearDeviceForm = function clearDeviceForm() {
  return {
    type: CLEAR_DEVICE_FORM,
    payload: {}
  };
};
export var CLEAR_DEVICE_FILTERS = 'CLEAR_DEVICE_FILTERS';
export var clearDeviceFilters = function clearDeviceFilters() {
  return {
    type: CLEAR_DEVICE_FILTERS
  };
};
export var CREATE_EDIT_DEVICE_FORM_CHANGED = 'CREATE_EDIT_DEVICE_FORM_CHANGED';
export var setDeviceForm = function setDeviceForm(form) {
  return {
    type: CREATE_EDIT_DEVICE_FORM_CHANGED,
    payload: form
  };
};
var registerDevicePromise = function registerDevicePromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, REGISTER_DEVICE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RegisterDevice',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var registerDevice = function registerDevice(customerId, data) {
  return function (dispatch) {
    return registerDevicePromise(dispatch, customerId, data);
  };
};
var removeDevicePromise = function removeDevicePromise(dispatch, customerId, deviceId) {
  return ThunkHelper(dispatch, REMOVE_DEVICE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/UnregisterDevice',
    data: {
      DeviceId: deviceId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var removeDevice = function removeDevice(customerId, deviceId) {
  return function (dispatch) {
    return removeDevicePromise(dispatch, customerId, deviceId);
  };
};
var retrieveCustomerDevicesPromise = function retrieveCustomerDevicesPromise(dispatch, customerId, includeRemoved) {
  return ThunkHelper(dispatch, RETRIEVE_DEVICES_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveDevices',
    data: {
      IncludeRemoved: includeRemoved
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrieveCustomerDevices = function retrieveCustomerDevices(customerId, includeRemoved) {
  return function (dispatch) {
    return retrieveCustomerDevicesPromise(dispatch, customerId, includeRemoved);
  };
};
export var SET_INCLUDED_FILTER = 'SET_DEVICE_INCLUDED_FILTER';
export var setIncludedFilter = function setIncludedFilter(includeFilter) {
  return {
    type: SET_INCLUDED_FILTER,
    payload: includeFilter
  };
};
export var SET_SELECTED_DEVICE = 'SET_SELECTED_DEVICE';
export var setSelectedDevice = function setSelectedDevice(device) {
  return {
    type: SET_SELECTED_DEVICE,
    payload: device
  };
};
var updateDevicePromise = function updateDevicePromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, UPDATE_DEVICE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/UpdateDevice',
    data: {
      SubscriberDevice: data
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var updateDevice = function updateDevice(customerId, data) {
  return function (dispatch) {
    return updateDevicePromise(dispatch, customerId, data);
  };
};
export var retrieveSubscriberFinanceDetailsPromise = function retrieveSubscriberFinanceDetailsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_DEVICE_FINANCING_DETAILS_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriberFinanceDetails',
    data: {},
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveSubscriberFinanceDetails = function retrieveSubscriberFinanceDetails(customerId) {
  return function (dispatch) {
    return retrieveSubscriberFinanceDetailsPromise(dispatch, customerId);
  };
};
export var retrieveDeviceRefundAmountPromise = function retrieveDeviceRefundAmountPromise(dispatch, subscriberProductId, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_DEVICE_REFUND_AMOUNT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveDeviceRefundAmount',
    data: {
      SubscriberDeviceRefundDetails: [{
        SubscriberProductId: subscriberProductId
      }]
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveDeviceRefundAmount = function retrieveDeviceRefundAmount(subscriberProductId, customerId) {
  return function (dispatch) {
    return retrieveDeviceRefundAmountPromise(dispatch, subscriberProductId, customerId);
  };
};
export var createDeviceAdjustmentPromise = function createDeviceAdjustmentPromise(dispatch, deviceDetails, customerId) {
  return ThunkHelper(dispatch, CREATE_DEVICE_ADJUSTMENT_TYPE, {
    method: 'post',
    url: 'SubscriberManagement/CreateDeviceAdjustment',
    data: deviceDetails,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var createDeviceAdjustment = function createDeviceAdjustment(deviceDetails, customerId) {
  return function (dispatch) {
    return createDeviceAdjustmentPromise(dispatch, deviceDetails, customerId);
  };
};
export var SET_DEVICE_FINANCING_WIDGET_SELECTED_DEVICE = 'SET_DEVICE_FINANCING_WIDGET_SELECTED_DEVICE';
export var setDeviceFinancingWidgetSelectedDevice = function setDeviceFinancingWidgetSelectedDevice(index) {
  return {
    type: SET_DEVICE_FINANCING_WIDGET_SELECTED_DEVICE,
    payload: index
  };
};